import React from "react";

const map = {
  red:    { bg: "bg-red-50",    text: "text-red-700",    ring: "ring-red-200",    label: "ALTA" },
  orange: { bg: "bg-orange-50", text: "text-orange-700", ring: "ring-orange-200", label: "MÉDIA/ALTA" },
  yellow: { bg: "bg-yellow-50", text: "text-yellow-800", ring: "ring-yellow-200", label: "ATENÇÃO" },
  green:  { bg: "bg-emerald-50",text: "text-emerald-700",ring: "ring-emerald-200",label: "OK" },
  blue:   { bg: "bg-blue-50",   text: "text-blue-700",   ring: "ring-blue-200",   label: "INFO" },
};

export default function RiskBadge({ level, label }) {
  const s = map[level] || map.blue;
  return (
    <span className={`inline-flex items-center px-2.5 py-1 rounded-full text-[11px] font-bold uppercase tracking-wider ring-1 ${s.bg} ${s.text} ${s.ring}`}>
      {label || s.label}
    </span>
  );
}
